import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles({
  fbButton: {
    backgroundColor: '#3C66C4'
  },
  errorContainer: {
    backgroundColor: 'rgb(253, 236, 234)',
    padding: '10px',
    color: 'red',
    borderRadius: '6px',
    marginTop: '20px',
  }
});